module.exports = __webpack_public_path__ + "static/media/product (9).c96043bc.jpg";